const STORAGE_KEY = "fr_whatsapp_recipients";

function identityKey(userId, companyId) {
  return `${String(userId || "").trim()}::${String(companyId || "").trim()}`;
}

export function saveWhatsAppRecipients({ userId, companyId, recipients }) {
  if (!userId || !companyId) return;
  const list = Array.isArray(recipients) ? recipients : [];
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        userId: String(userId),
        companyId: String(companyId),
        key: identityKey(userId, companyId),
        recipients: list,
        savedAt: new Date().toISOString(),
      })
    );
  } catch {
    /* ignore quota / private mode */
  }
}

export function loadWhatsAppRecipients({ userId, companyId }) {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!parsed || identityKey(parsed.userId, parsed.companyId) !== identityKey(userId, companyId)) {
      return [];
    }
    return Array.isArray(parsed.recipients) ? parsed.recipients : [];
  } catch {
    return [];
  }
}

export function clearWhatsAppRecipients() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
